import { FunctionComponent } from 'react';
import styles from './Success.module.scss';
import { SuccessScreen } from 'components/UI/V3/SuccessScreen/SuccessScreen';

interface SuccessProps {
    roomName: string;
    updated?: boolean;
    className?: string;
    onClick?: () => void;
}

export const Success: FunctionComponent<SuccessProps> = props => {
    return (
        <SuccessScreen
            title="Good Job"
            message={
                <span className={styles.message}>
                    <strong>{props.roomName}</strong> was successfully {props.updated ? 'updated' : 'added'}.
                </span>
            }
            buttonLabel="Go to Rooms & Spaces"
            className={props.className}
            onClick={props.onClick}
        />
    );
};

export default Success;
